// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import TopUpBalanceHash from './TopUpBalanceHash';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(TopUpBalanceHash);
